export default __webpack_public_path__ + "static/logo-2699222da52593a682eff28e28db0356.svg";